<template>
	<div class="h-screen pt-6 flex flex-col bg-white">
		<Container class="w-full">
			<PageHeading title="Admin Regulations"/>
		</Container>

		<TabLayout :tabs="tabs"/>

		<div class="flex-1 flex flex-col overflow-hidden">
			<router-view class="flex-1"></router-view>
		</div>

	</div>
</template>

<script>
import TabLayout from "@/Layouts/TabLayout.vue";
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";

export default {
	name: "RegulationAdminLayout",
	components: {Container, PageHeading, TabLayout},
	data() {
		return {}
	},
	computed: {
		tabs() {
			return [
				{
					label: 'Regulations',
					current: this.$route.name === 'admin.regulations' || this.$route.name.startsWith('admin.regulations.regulation'),
					to: {name: 'admin.regulations'},
					permission: 'create:regulations|update:regulations',
				},
			].filter(t => t.permission === undefined || this.$auth.hasPermission(t.permission))
		}
	},
}
</script>

<style scoped>

</style>
